import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import auth from './authReducer';
import attachments from './attachmentsReducer';
import browserNotifications from './browserNotificationsReducer';
import chats from './chatsReducer';
import errors from './errorsReducer';
import identity from './identityReducer';
import messages from './messagesReducer';
import messagesPaging from './messagesPagingReducer';
import modal from './modalReducer';
import pdf from './pdfReducer';
import publicChannels from './publicChannelsReducer';
import routerLocations from './routerLocationsReducer';
import selectedMessages from './selectedMessagesReducer';
import socket from './socketReducer';
import users from './usersReducer';
import videos from './videosReducer';
import view from './viewReducer';


export default history => combineReducers({
  router: connectRouter(history),
  auth,
  attachments,
  browserNotifications,
  chats,
  errors,
  identity,
  messages,
  messagesPaging,
  modal,
  pdf,
  publicChannels,
  routerLocations,
  selectedMessages,
  socket,
  users,
  videos,
  view,
});
